import randomImagePicker from "components/RandomImagePicker/RandomImagePicker";


export default randomImagePicker;